import React from 'react'

import { useFetchApplicationCount } from '@/core/hooks/useFetchApplicationCount'
import { useFetchRecommendationsPositions } from '@/core/hooks/useFetchRecommendationsPositions'

import styles from './styles'

const CandidatesNavItemLabel = () => {
  const { count: applicationCount } = useFetchApplicationCount()
  const { recommendationListCount } = useFetchRecommendationsPositions()
  const isIndicatorVisible = applicationCount > 0 || recommendationListCount > 0

  return (
    <>
      Candidates
      {isIndicatorVisible && (
        <span className={styles.indicator}>
          <span className={styles.accessiblyHidden}>You have pending applications and recommendations to review</span>
        </span>
      )}
    </>
  )
}

export default CandidatesNavItemLabel
